import { render } from "./BaseAuth.vue?vue&type=template&id=0a206f76"
import script from "./BaseAuth.vue?vue&type=script&lang=js"
export * from "./BaseAuth.vue?vue&type=script&lang=js"

import "./BaseAuth.vue?vue&type=style&index=0&id=0a206f76&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__